<template>
  <div :class="classes">
    <ul class="list-unstyled">
      <li v-for="(item, index) in nav" :key="index">
        <router-link
          :to="{ name: item.link }"
          :class="linkClasses(item)"
          v-if="showLink(item)"
          >
          {{ $t(item.label) }}
        </router-link>
      </li>
      <!-- <li>
        <router-link :to="{ name: 'newCard' }" class="dx-mobile-nav__link" @click.native="onClick">
          {{ $t('newCard') }}
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'myCards' }" class="dx-mobile-nav__link" @click.native="onClick">
          {{ $t('myCards') }}
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'home' }" class="dx-mobile-nav__link" @click.native="onClick">
          {{ $t('settings') }}
        </router-link>
      </li>
      <li v-if="!loggedIn">
        <router-link :to="{ name: 'login' }" class="dx-mobile-nav__link" @click.native="onClick">
          {{ $t('login') }}
        </router-link>
      </li>
      <li v-if="loggedIn">
        <router-link :to="{ name: 'logout' }" class="dx-mobile-nav__link" @click.native="onClick">
          {{ $t('logout') }}
        </router-link>
      </li> -->
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'dx-mobile-nav',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      loggedIn: 'getLoggedIn',
      nav: 'getNav'
    }),
    classes () {
      return {
        'dx-mobile-nav': true,
        'dx-mobile-nav--active': this.active
      }
    }
  },
  methods: {
    onClick (e) {
      this.$emit('click', e)
    },
    showLink (item) {
      if (typeof item.auth !== 'undefined') {
        if (item.auth && !this.loggedIn) {
          return false
        } else if (!item.auth && this.loggedIn) {
          return false
        }
      }
      if (item.mediumUp === true) {
        return false
      }
      return true
    },
    linkClasses (item) {
      let classes = {
        'dx-mobile-nav__link': true
      }
      if (item.class) {
        classes[item.class] = true
      }
      return classes
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxMobileNav.vue